import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaCheck, FaCarSide, FaMoneyBillWave, FaFileSignature, FaCalendarAlt, FaClock, FaCreditCard, FaShieldAlt, FaUserTie } from 'react-icons/fa';
import './SalesSystem.css';

/**
 * Tamamen modüler ve özelleştirilebilir SalesSystem bileşeni
 * @param {Object} props - Bileşen özellikleri
 * @param {boolean} props.showBanner - Banner bölümünü göster/gizle
 * @param {boolean} props.showSteps - Adımlar bölümünü göster/gizle
 * @param {boolean} props.showStepsTitle - Adımlar bölümünün başlığını göster/gizle
 * @param {boolean} props.showAdvantages - Avantajlar bölümünü göster/gizle
 * @param {boolean} props.showFAQ - SSS bölümünü göster/gizle
 * @param {boolean} props.showCTA - CTA bölümünü göster/gizle
 * @param {string} props.stepsTitle - Adımlar bölümü başlık metni
 * @param {string} props.advantagesTitle - Avantajlar bölümü başlık metni
 * @param {string} props.faqTitle - SSS bölümü başlık metni
 * @param {string} props.ctaId - CTA butonu için sayfa içi bağlantı ID'si
 */
const SalesSystem = ({
    //showBanner = true,
    showSteps = true,
    showStepsTitle = false,
    showAdvantages = true,
    showFAQ = true,
    showCTA = true,
    stepsTitle = "Otoprime ile Araç Alım Süreci Çok ",
    advantagesTitle = "Neden Otoprime?",
    faqTitle = "Sık Sorulan Sorular",
    ctaId = "sales-system-cta"
}) => {
    // Araç alım süreci adımları
    const salesSteps = [
        {
            id: 1,
            icon: <FaCarSide />,
            title: "Hayalinizdeki aracı seçin",
            description: "Geniş araç listemizden size uygun olanı seçin ve teklif alın"
        },
        {
            id: 2,
            icon: <FaMoneyBillWave />,
            title: "%30 peşinatı hazırlayın",
            description: "Araç bedelinin %30'si kadar peşinat ödeyin"
        },
        {
            id: 3,
            icon: <FaFileSignature />,
            title: "Başvurunuzu tamamlayın",
            description: "Online başvurunuzu kolayca tamamlayın ve onay bekleyin"
        },
        {
            id: 4,
            icon: <FaCalendarAlt />,
            title: "Taksit ödemelerinizi yapın",
            description: "Aylık taksitlerinizi zamanında ödeyerek aracınızın keyfini çıkarın"
        }
    ];

    // Otoprime'in sağladığı avantajlar
    const advantages = [
        {
            icon: <FaClock />,
            text: "Hızlı ve kolay başvuru süreci"
        },
        {
            icon: <FaCalendarAlt />,
            text: "Esnek ödeme planları"
        },
        {
            icon: <FaMoneyBillWave />,
            text: "48 aya varan vade seçenekleri"
        },
        {
            icon: <FaCreditCard />,
            text: "Kredi kartına gerek yok, senetle ödeme"
        },
        {
            icon: <FaShieldAlt />,
            text: "Şeffaf fiyatlandırma politikası"
        },
        {
            icon: <FaUserTie />,
            text: "Profesyonel danışmanlık hizmeti"
        }
    ];

    // SSS (Sık Sorulan Sorular)
    const faqs = [
        {
            question: "Otoprime'dan kimler araç satın alabilir?",
            answer: "18 yaşını doldurmuş, düzenli gelir sahibi ve gerekli belgeleri sağlayabilen herkes Otoprime'dan araç satın alabilir."
        },
        {
            question: "Başvuru için hangi belgelere ihtiyacım var?",
            answer: "Kimlik fotokopisi, ikametgah belgesi, gelir belgesi ve peşinat ödeme dekontu gibi temel belgeler gerekmektedir. Başvuru sırasında detaylı bilgi verilecektir."
        },
        {
            question: "Aylık ödeme tutarımı nasıl öğrenebilirim?",
            answer: "Ana sayfamızdaki ödeme hesaplama aracını kullanarak, seçtiğiniz araç ve vade için aylık ödeme tutarınızı öğrenebilirsiniz."
        },
        {
            question: "Araç teslim süresi ne kadardır?",
            answer: "Başvurunuzun onaylanmasını takiben, genellikle 3-5 iş günü içerisinde aracınızı teslim alabilirsiniz."
        }
    ];

    return (
        <div className="sales-system-page">

            {/* Nasıl Çalışır Bölümü */}
            {showSteps && (
                <section className="how-it-works py-5">
                    <Container>
                        {/* FAQ'daki gibi başlık ve sarı çizgi ekledik */}
                        <div className="text-center mb-5">
                            <h2 className="page-title mb-2">KREDİ BAŞVURU SÜRECİ</h2>
                            <div className="title-underline"></div>
                        </div>

                        <Row className="text-center">
                            {salesSteps.map((step) => (
                                <Col md={3} className="mb-4" key={step.id}>
                                    <div className="step-icon">{step.icon}</div>
                                    <div className="step-circle">{step.id}</div>
                                    <h4 className="step-title">{step.title}</h4>
                                    <p className="step-description">{step.description}</p>
                                </Col>
                            ))}
                        </Row>
                        <div className="text-center mt-4">
                            <Button variant="primary" size="lg" as={Link} to="/application" className="cta-button">
                                Hemen Basvur <FaArrowRight className="ms-2" />
                            </Button>
                        </div>
                    </Container>
                </section>
            )}

            {/* Avantajlar Bölümü */}
            {showAdvantages && (
                <section className="advantages py-5 bg-light">
                    <Container>
                        <h2 className="section-title text-center mb-5">{advantagesTitle}</h2>
                        <Row className="justify-content-center">
                            <Col lg={8}>
                                <div className="advantages-list">
                                    {advantages.map((advantage, index) => (
                                        <div className="advantage-item" key={index}>
                                            <div className="advantage-icon">{advantage.icon}</div>
                                            <div className="advantage-text">{advantage.text}</div>
                                        </div>
                                    ))}
                                </div>
                            </Col>
                            <Col lg={4} className="d-flex align-items-center justify-content-center mt-4 mt-lg-0">
                                <img
                                    src="/images/why.png"
                                    alt="Otoprime Avantajları"
                                    className="img-fluid advantages-image"
                                />
                            </Col>
                        </Row>
                    </Container>
                </section>
            )}

            {/* Sık Sorulan Sorular */}
            {showFAQ && (
                <section className="faq-section py-5">
                    <Container>
                        <h2 className="section-title text-center mb-5">{faqTitle}</h2>
                        <Row className="justify-content-center">
                            <Col lg={8}>
                                <div className="faq-list">
                                    {faqs.map((faq, index) => (
                                        <Card className="mb-3 faq-item" key={index}>
                                            <Card.Body>
                                                <h4 className="faq-question">{faq.question}</h4>
                                                <p className="faq-answer">{faq.answer}</p>
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </div>
                                <div className="text-center mt-5">
                                    <p className="more-questions">Daha fazla soru için bize ulaşın</p>
                                    <Button variant="outline-primary" size="lg" as={Link} to="/contact" className="contact-button">
                                        İletişime Geç
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            )}

            {/* Başvuru CTA Bölümü */}
            {showCTA && (
                <section id={ctaId} className="apply-cta py-5 bg-primary text-white">
                    <Container className="text-center">
                        <h2 className="mb-4">Hayalinizdeki araca hemen kavuşun!</h2>
                        <p className="mb-4">Otoprime'ın avantajlı satış sistemi ile senetle araç sahibi olmak için hemen başvurun.</p>
                        <Button variant="light" size="lg" as={Link} to="/apply" className="apply-button">
                            Hemen Başvur
                        </Button>
                    </Container>
                </section>
            )}
        </div>
    );
};

export default SalesSystem;